/**
 * 기본 조립 서비스, 프리미엄 조립 서비스, 윈도우 상품번호
 * 동봉서비스 : 1099785
 * 기본 조립 서비스(1대분) : 76709
 * 기본 조립 + 1년 전국 출장 A/S (1대분) : 1154496
 * 기본 조립 + 2년 전국 출장 A/S (1대분) : 10995920
 * 프리미엄 조립 서비스(1대분) : 11275005
 * 프리미엄 조립 + 1년 전국 출장 A/S (1대분) : 11275006
 * 프리미엄 조립 + 2년 전국 출장 A/S (1대분) : 11275007
 * 출장 PC 설치 서비스 : 11653042
 * @type {string[]}
 */


/**
 * 최초 페이지 로딩시 api로 호출하여 정보를 받는 서비스들
 * @type {string[]}
 */
export const serviceItems = ['1099785','76709','1154496','10995920','11275005','11275006','11275007','1099814','10572369','10572371','11653042']

export const serviceItemsNumber = [1099785,76709,1154496,10995920,11275005,11275006,11275007,1099814,10572369,10572371]

export const serviceASItems = ['1099785','76709','1154496','10995920','11275005','11275006','11275007']

/**
 * 조립 + AS 인 서비스만 배열에 string으로 선언한 변수
 * @type {string[]}
 */
export const KeyOfVisitServiceAdd = ['1154496','10995920','11275006','11275007']

/**
 * 조립서비스 6가지를 배열에 string으로 선언한 변수
 * @type {string[]}
 */
export const ASSEMBLE_SERVICE = ['76709','1154496','10995920','11275005','11275006','11275007']

/**
 * 윈도우 상품을 배열에 string으로 선언해둔 변수
 * @type {string[]}
 */
// export const windowsItem = ['466610','471889','472129','663036','617335','471883','472117', '663000', '487285', '617740','472123','589544','11083786','10572369','11221078','10572370','11166998','11083787','10572371','10572372']



// WEBPACK FOOTER //
// ./src/estimate_list/utils/serviceItem.js